// Templates management page (/templates) and the Save-as-template dialog
// used by all three builders (backlog DOCS-21). templateType.* mirrors the
// documents list's own type badges (QTE/INV/G702).
export const en = {
  "templateType.standard": "QTE",
  "templateType.invoice": "INV",
  "templateType.g702": "G702",

  "templates.eyebrow": "Reusable starting points",
  "templates.title": "Templates",
  "templates.subtitle": "Saved shapes of work — line items, rates and retainage — ready to start a new document from.",
  "templates.searchPlaceholder": "Search templates…",
  "templates.empty.title": "No templates yet",
  "templates.empty.body": "Save any quote, invoice or pay application as a template and it will show up here.",
  "templates.empty.action": "New document",
  "templates.search.empty.title": "No templates match that search.",
  "templates.search.empty.body": "Try a different name or document type.",
  "templates.card.created": "Created {date}",
  "templates.card.used": "Used {n}×",
  "templates.card.lastUsed": "Last used {age}",
  "templates.never": "never",
  "templates.age.today": "today",
  "templates.age.days": "{n}d ago",
  "templates.age.weeks": "{n}w ago",
  "templates.age.months": "{n}mo ago",
  "templates.action.rename": "Rename",
  "templates.action.delete": "Delete",
  "templates.deleteConfirm": "Delete the template \"{name}\"? This can't be undone.",
  "templates.renamed": "Renamed to \"{name}\"",
  "templates.deleted": "Deleted \"{name}\"",
  "templates.rename.title": "Rename template",
  "templates.rename.body": "This only changes the name — the saved content stays the same.",
  "templates.rename.save": "Save name",

  "docs.template.saveAction": "Save as template",
  "docs.template.dialog.title": "Save as template",
  "docs.template.dialog.body": "Saves the line items and rates currently filled in — not the client or document number.",
  "docs.template.dialog.label": "Template name",
  "docs.template.dialog.placeholder": "e.g. Service Call · T&M",
  "docs.template.dialog.cancel": "Cancel",
  "docs.template.dialog.save": "Save template",
  "docs.template.saved": "Template saved",
  "docs.template.saved.manage": "Manage",
} as const;

export const es = {
  "templateType.standard": "COT",
  "templateType.invoice": "FACT",
  "templateType.g702": "G702",

  "templates.eyebrow": "Puntos de partida reutilizables",
  "templates.title": "Plantillas",
  "templates.subtitle": "Formas de trabajo guardadas — partidas, tarifas y retención — listas para iniciar un nuevo documento.",
  "templates.searchPlaceholder": "Buscar plantillas…",
  "templates.empty.title": "Aún no hay plantillas",
  "templates.empty.body": "Guarda cualquier cotización, factura o solicitud de pago como plantilla y aparecerá aquí.",
  "templates.empty.action": "Nuevo documento",
  "templates.search.empty.title": "Ninguna plantilla coincide con esa búsqueda.",
  "templates.search.empty.body": "Prueba otro nombre o tipo de documento.",
  "templates.card.created": "Creada {date}",
  "templates.card.used": "Usada {n}×",
  "templates.card.lastUsed": "Última vez {age}",
  "templates.never": "nunca",
  "templates.age.today": "hoy",
  "templates.age.days": "hace {n}d",
  "templates.age.weeks": "hace {n}sem",
  "templates.age.months": "hace {n}mes",
  "templates.action.rename": "Renombrar",
  "templates.action.delete": "Eliminar",
  "templates.deleteConfirm": "¿Eliminar la plantilla \"{name}\"? Esto no se puede deshacer.",
  "templates.renamed": "Renombrada a \"{name}\"",
  "templates.deleted": "Eliminada \"{name}\"",
  "templates.rename.title": "Renombrar plantilla",
  "templates.rename.body": "Esto solo cambia el nombre — el contenido guardado sigue igual.",
  "templates.rename.save": "Guardar nombre",

  "docs.template.saveAction": "Guardar como plantilla",
  "docs.template.dialog.title": "Guardar como plantilla",
  "docs.template.dialog.body": "Guarda las partidas y tarifas actuales — no el cliente ni el número de documento.",
  "docs.template.dialog.label": "Nombre de la plantilla",
  "docs.template.dialog.placeholder": "p. ej. Llamada de servicio · T&M",
  "docs.template.dialog.cancel": "Cancelar",
  "docs.template.dialog.save": "Guardar plantilla",
  "docs.template.saved": "Plantilla guardada",
  "docs.template.saved.manage": "Administrar",
} as const;
